import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './AcknowledgedStatement.module.scss';
import { useLocaleFormatter } from '@casops/shared/hooks/useLocaleFormatter';
import { SafetyAlertBasicModel } from '@casops/store/apis/personnelSafetyApi';

interface AcknowledgedStatementProps extends Pick<SafetyAlertBasicModel, 'ackAt' | 'ackBy'> {}

export const AcknowledgedStatement = ({
  ackAt,
  ackBy,
}: AcknowledgedStatementProps): ReactElement => {
  const { t } = useTranslation();
  const { showDateOnlyFromIso, showTimeOnlyFromIso } = useLocaleFormatter();

  return (
    <div className={styles.container}>
      <p className={styles.text}>
        {ackAt && (
          <>
            {t('AlertAcknowledgedAt', {
              date: showDateOnlyFromIso(ackAt),
              time: showTimeOnlyFromIso(ackAt),
            })}
            <br />
          </>
        )}
        {ackBy && t('AlertAcknowledgedBy', { name: ackBy.n })}
      </p>
    </div>
  );
};
